import React, { Component } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { MESSAGE_STATUS_CONSTANT } from '../../constants/messageStatusConstant';
import { MESSAGE_TYPE_CONSTANT } from '../../constants/messageTypeConstant';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_CLOSE_UPDATE_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import API_CHAT from '../../api/apiChat';
import IconCheckmarkCircle from '../../assets/icons/IconCheckmarkCircle';
import ActionType from '../../redux/reducer/globalActionType';
import Alert from '../Alert/Alert';

class TicketClose extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCloseTicketModal: false,
            showButtonRoomType: false,
            showButtonEscalate: false,
            isEscalateToBugValidator: false,
            closeType: '1',
            rootCauseDesc: '',
            solution: '',
            closeReasonOption: {
                data: [],
                value: ''
            },
            note: '',
            lastVectorX: 0,
            lastVectorY: 0,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    putDataCloseTicketWithoutPatch = data => {
        API_TICKET_LIST.putDataCloseTicketWithoutPatch(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false,
                    showCloseTicketModal: false
                }, async () => {
                    await this.getListRoom();
                    await this.handleCloseRoomChat(getContent(res));
                    this.postDataUploadChat();
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_SOLUTION);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    putDataCloseTicketWithoutSolution = data => {
        API_TICKET_LIST.putDataCloseTicketWithoutSolution(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false,
                    showCloseTicketModal: false
                }, async () => {
                    await this.getListRoom();
                    await this.handleCloseRoomChat(getContent(res));
                    this.postDataUploadChat();
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_SOLUTION);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    putDataCloseTicketChangeRequest = data => {
        API_TICKET_LIST.putDataCloseTicketChangeRequest(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false,
                    showCloseTicketModal: false
                }, async () => {
                    await this.getListRoom();
                    await this.handleCloseRoomChat(getContent(res));
                    this.postDataUploadChat();
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_SOLUTION);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    putDataCloseTicketWorkAround = data => {
        API_TICKET_LIST.putDataCloseTicketWorkAround(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false,
                    showCloseTicketModal: false
                }, async () => {
                    await this.getListRoom();
                    await this.handleCloseRoomChat(getContent(res));
                    this.postDataUploadChat();
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_SOLUTION);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    handleCloseRoomChat = message => {
        const roomId = `${this.props.userDetail.client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
        const payload = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: this.props.data.pic_client_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.SEND,
                    message_id: uuidv4(),
                    message_model: {
                        additional_key: '',
                        content: {
                            text: message
                        },
                        created_at: moment().tz("Asia/Jakarta").valueOf(),
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: 'N',
                        is_forward: 0,
                        local_id: 'local_id',
                        message_reply_id: '',
                        room_id: roomId,
                        type_message_id: MESSAGE_TYPE_CONSTANT.TEXT,
                        vector_x: this.state.lastVectorX + 1,
                        vector_y: this.state.lastVectorY
                    }
                }
            }
        }

        const websocket = this.props.websocket;
        localStorage.setItem('closeRoomChat', 'true');
        return websocket.send(JSON.stringify(payload));
    }

    getListRoom = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true' && this.props.userDetail.client_id && this.props.data.pic_client_id) {
            const roomId = `${this.props.userDetail.client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
            return API_CHAT.getListRoom(1, 100, this.props.token)
                .then(res => {
                    const data = res.data.data.filter(item => item.room_status === 'Active');
                    const filteredData = data.find(room => room.room_id === roomId);
                    this.setState({
                        lastVectorX: filteredData.message.vector_x,
                        lastVectorY: filteredData.message.vector_y
                    });
                })
        }
    }

    postDataUploadChat = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true' && this.props.userDetail.client_id && this.props.data.pic_client_id) {
            const roomId = `${this.props.userDetail.client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
            const data = {
                room_id: roomId,
                user_id: this.props.userDetail.client_id,
                ticket_id: this.props.data.id
            };
            API_TICKET_LIST.postDataUploadChat(data, this.props.token)
        }
    }

    getListClosedTicket = () => {
        API_TICKET_LIST.getListClosedTicket(1, 100, this.props.token)
            .then(res => {
                let closeData = getContent(res).map(close => ({
                    value: close.id,
                    label: close.description
                }))
                this.setState({
                    closeReasonOption: {
                        ...this.state.closeReasonOption,
                        data: closeData
                    }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleShowCloseTicketModal = () => {
        if (this.props.data.root_cause_id === '') {
            return this.setState({ showErrorAlert: true });
        }
        this.setState({ showCloseTicketModal: true });
        this.getListClosedTicket();
    }

    handleChangeCloseType = e => {
        if (e.target.value === "4") {
            this.setState({
                showButtonEscalate: true,
                showButtonRoomType: false
            });
        } else {
            this.setState({
                showButtonEscalate: false,
                showButtonRoomType: false,
                isEscalateToBugValidator: false
            });
        }
        this.setState({ closeType: e.target.value });
    }

    handleEscalateBugValidator = () => {
        this.setState({ isEscalateToBugValidator: true });
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeCloseReason = data => {
        this.setState({
            closeReasonOption: {
                ...this.state.closeReasonOption,
                value: data
            }
        })
    }

    handleSubmit = () => {
        if (this.state.closeType === "1") {
            const data = {
                root_cause: this.props.data.root_cause_id,
                root_cause_desc: this.state.rootCauseDesc,
                solution: this.state.solution,
                note: this.state.note,
                updated_at: this.props.data.updated_at,
            };
            this.putDataCloseTicketWithoutPatch(data);
        }

        if (this.state.closeType === "2") {
            const data = {
                root_cause: this.props.data.root_cause_id,
                remark_close_id: this.state.closeReasonOption.value.value,
                note: this.state.note,
                updated_at: this.props.data.updated_at,
            };
            this.putDataCloseTicketWithoutSolution(data);
        }

        if (this.state.closeType === "3") {
            const data = {
                root_cause: this.props.data.root_cause_id,
                root_cause_desc: this.state.rootCauseDesc,
                solution: this.state.solution,
                note: this.state.note,
                updated_at: this.props.data.updated_at,
            };
            this.putDataCloseTicketChangeRequest(data);
        }

        if (this.state.closeType === "4") {
            const data = {
                root_cause: this.props.data.root_cause_id,
                root_cause_desc: this.state.rootCauseDesc,
                escalate_to: this.state.isEscalateToBugValidator ? "bv" : "",
                solution: this.state.solution,
                note: this.state.note,
                updated_at: this.props.data.updated_at,
            };
            this.putDataCloseTicketWorkAround(data);
        }
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false;
        return true;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_CLOSE_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btncloseticket" className={this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) && this.checkCustomerServiceAssignee() ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={this.handleShowCloseTicketModal}>
                    <IconCheckmarkCircle />
                    <span className="ml-1">Tutup Tiket</span>
                </button>
                <div className={this.state.showCloseTicketModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/2">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btncloseticketmodal" onClick={() => this.setState({ showCloseTicketModal: false })} />
                            </div>
                            <div>
                                <div className="flex items-center justify-between">
                                    <div className="text-gray-600">
                                        <p className="mb-1">
                                            <span>{this.props.data.ticket_no} | {this.props.data.percentage}% </span>
                                        </p>
                                        <p className="text-lg font-bold">{this.props.data.issue_title}</p>
                                        <p className="text-sm capitalize my-1">{this.props.data.customer} | {this.props.data.tracker} | {moment.utc(this.props.data.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                        <div className="flex text-sm my-1">
                                            <p className="truncate mr-1" style={{ maxWidth: "180px" }} title={this.props.data.pic_name}>PIC : {this.props.data.pic_name}</p>
                                            <p className="truncate" style={{ maxWidth: "180px" }} title={this.props.data.cs}>| CS : {this.props.data.cs}</p>
                                        </div>
                                    </div>
                                    <div className="flex flex-col justify-center items-end text-gray-700">
                                        <select id="ddlrootcause" className="outline-none custom-select my-1" disabled><option>{this.props.data.root_cause_description}</option></select>
                                        <select id="ddlcomplaint" className="outline-none custom-select my-1" disabled><option>{this.props.data.complaint}</option></select>
                                        <select id="ddlcomplaintcategory" className="outline-none custom-select my-1" disabled><option>{this.props.data.complaint_category}</option></select>
                                        <select id="ddlcomplaintsub" className="outline-none custom-select my-1" disabled><option>{this.props.data.complaint_sub}</option></select>
                                    </div>
                                </div>
                                <div className="text-sm flex mt-1 mb-3">
                                    <div className="flex items-center mr-2">
                                        <input type="radio" id="1" name="close-type" value="1" onChange={this.handleChangeCloseType} defaultChecked />
                                        <label className="mx-1" htmlFor="1">None</label>
                                    </div>
                                    <div className="flex items-center">
                                        <input type="radio" id="2" name="close-type" value="2" onChange={this.handleChangeCloseType} />
                                        <label className="mx-1" htmlFor="2">Close</label>
                                    </div>
                                    {/* <div className={this.state.showButtonRoomType ? "block" : "hidden"}>
                                        <button type="button" id="btnisproblemsolved" className={this.state.isProblemSolved ? "bg-lightblue rounded-l text-white text-xs px-2 py-1 border-r border-white" : "bg-gray-500 rounded-l text-white text-xs px-2 py-1 border-r border-white"} onClick={() => this.handleProblemSolved()}>Masalah Telah Selesai</button>
                                        <button type="button" id="btnisunreachablepic" className={this.state.isUnreachablePic ? "bg-lightblue rounded-r text-white text-xs px-2 py-1 border-l border-white" : "bg-gray-500 rounded-r text-white text-xs px-2 py-1 border-l border-white"} onClick={() => this.handleUnreachablePic()}>PIC Tidak Dapat Dihubungi</button>
                                    </div> */}
                                    <div className="flex items-center mx-2">
                                        <input type="radio" id="3" name="close-type" value="3" onChange={this.handleChangeCloseType} />
                                        <label className="mx-1" htmlFor="3">Change Request</label>
                                    </div>
                                    <div className="flex items-center mr-2">
                                        <input type="radio" id="4" name="close-type" value="4" onChange={this.handleChangeCloseType} />
                                        <label className="mx-1" htmlFor="4">Work Around</label>
                                    </div>
                                    <div className={this.state.showButtonEscalate ? "block" : "hidden"}>
                                        <button type="button" id="btnisescalatetobugvalidator" className={this.state.isEscalateToBugValidator ? "bg-lightblue rounded text-white text-xs px-2 py-1" : "bg-gray-500 rounded text-white text-xs px-2 py-1"} onClick={() => this.handleEscalateBugValidator()}>Eskalasi Ke Bug Validator</button>
                                    </div>
                                </div>
                                {
                                    this.state.closeType === '2'
                                        ? <div className="mb-1">
                                            <label htmlFor="ddsclosereason">Alasan <span className="text-darkred">*</span></label>
                                            <Select
                                                id="ddsclosereason"
                                                placeholder="Pilih Alasan *"
                                                options={this.state.closeReasonOption.data}
                                                value={this.state.closeReasonOption.value}
                                                onChange={this.handleChangeCloseReason}
                                            />
                                        </div>
                                        : <div>
                                            <label htmlFor="tmlrootcausedesc">Penyebab masalah <span className="text-darkred">*</span></label>
                                            <textarea id="tmlrootcausedesc" className="form-control resize-none h-32" placeholder="Tulis Masalah" name="rootCauseDesc" onChange={this.handleChange} maxLength="256" />
                                            <label htmlFor="tmlsolution">Pemberian solusi  <span className="text-darkred">*</span></label>
                                            <textarea id="tmlsolution" className="form-control resize-none h-48" placeholder="Tulis Pemberian Solusi" name="solution" onChange={this.handleChange} minLength="10" maxLength="256" />
                                        </div>
                                }
                                <label htmlFor="tmlnote">Note (untuk internal)</label>
                                <textarea id="tmlnote" className="form-control resize-none h-20" placeholder="Masukan Note" name="note" value={this.state.note} onChange={this.handleChange} maxLength="256" />
                                <span className="text-darkred">* keterangan wajib diisi</span>
                                <div className="flex justify-center items-center">
                                    <button type="submit" id="btncloseticket" className="bg-lightblue rounded text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.setState({ showConfirmAlert: true })}>Tutup Tiket</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin menutup tiket ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleSubmit()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil tutup tiket!" />
                <Alert show={this.state.showErrorAlert} icon="warning" title="Silahkan isi root cause terlebih dahulu!" close={() => this.setState({ showErrorAlert: false })} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        sign: state.authentication.sign,
        userDetail: state.authentication.userDetail,
        websocket: state.grochatWebsocket.websocket
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketClose));